import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const PropertyInsuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section property-insurance-fin">
                <h2 className="other-pages-title">Property Insurance</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/property-insurance-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Property Insurance</span>
                </p>
            </div>
            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is Property Insurance?</h2>

                <p className="info-loan-description-smco">
                    Property insurance is a type of coverage that protects buildings, homes, and their contents from financial loss due to damage or theft. It covers risks like fire, flood, storm, burglary, and vandalism, providing compensation to restore or repair the property. This insurance is essential for homeowners, landlords, and businesses to safeguard their real estate investments.
                    <br /><br />
                    There are different types of property insurance, including homeowners insurance, renters insurance, and commercial property insurance. Policies can be customized with additional coverage for high-value items, liability protection, and natural disaster coverage. Premiums depend on location, property value, construction type, and coverage limits.
                    <br /><br />
                    Property insurance not only protects against physical damage but also covers liability if someone is injured on your property. It's mandatory for mortgaged properties and highly recommended for all real estate owners. Regular policy reviews and updates ensure adequate coverage as property values change.
                    <br /><br />
                    Choosing the right property insurance involves assessing your property's value, location risks, and personal needs. Working with insurance experts can help you get comprehensive coverage at competitive rates.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Damage coverage:</strong> Protection against fire, water, storm, and other perils.</li>
                        <li><strong>Theft protection:</strong> Covers burglary and theft of property contents.</li>
                        <li><strong>Liability coverage:</strong> Protection if someone is injured on your property.</li>
                        <li><strong>Additional living expenses:</strong> Covers temporary housing during repairs.</li>
                        <li><strong>Valuable items:</strong> Special coverage for jewelry, art, and high-value possessions.</li>
                        <li><strong>Tax benefits:</strong> Premiums may be tax-deductible in some cases.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Types of Property Insurance</h3>
                    <ul className="info-types-list-smco">
                        <li><strong>Homeowners Insurance:</strong> For residential properties and contents.</li>
                        <li><strong>Commercial Property Insurance:</strong> For business properties and assets.</li>
                        <li><strong>Renters Insurance:</strong> For tenants to protect personal belongings.</li>
                        <li><strong>Condominium Insurance:</strong> For condo owners covering personal units.</li>
                        <li><strong>Flood Insurance:</strong> Specialized coverage for flood damage.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Financial security:</strong> Protection against costly repairs and replacements.</li>
                        <li><strong>Peace of mind:</strong> Assurance that your property is safeguarded.</li>
                        <li><strong>Mortgage requirement:</strong> Often required by lenders for financed properties.</li>
                        <li><strong>Liability protection:</strong> Covers legal costs from property-related incidents.</li>
                        <li><strong>Customizable coverage:</strong> Tailor policies to specific needs and risks.</li>
                    </ul>
                </div>
            </div>
            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default PropertyInsuranceInfo;
